<template>
  <div class="register">
    <header class="header">
      <div class="header-container">
        <div class="header-logo">
          <div class="logo" @click="handleClickLogo">
            <img :src="config.logo1" />
          </div>
          <img :src="require('@/assets/images/slogan.png')" />
        </div>
      </div>
    </header>
    <main class="main" :style="{
      background: `url(${login_bg_image}) no-repeat`,
      backgroundSize: 'cover'
    }">
      <div class="register-box">
        <div class="register-title">
          <span class="register-title-text">注册</span>
          <span class="register-title-text2">Login and getting started</span>
        </div>
        <el-form class="form" ref="formRef" :model="form" :rules="rules" label-position="top">
          <el-form-item prop="account">
            <div class="form-item-title">账号</div>
            <el-input type="text" class="input" v-model="form.account" placeholder="请输入手机号码" maxlength="11" autocomplete="off">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="form-item-title">验证码</div>
            <div class="flex-space-between">
              <el-input type="text" class="input" v-model="form.code" placeholder="请输入验证码" />
              <el-button class="getCode" type="warning" :disabled="countdown > 0 || !isPhoneValid" @click="getVerificationCode">
                {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item prop="checked">
            <div class="form-item-label">
              <el-checkbox v-model="form.checked">我已阅读并同意</el-checkbox>
              <a rel="noopener noreferrer" @click="showDialog('yhxz')">用户协议</a>
              <span>和</span>
              <a rel="noopener noreferrer" @click="showDialog('yszc')">隐私政策</a>
            </div>
          </el-form-item>
          <div class="form-item">
            <div class="btn-group">
              <router-link to="/login" class="btn btn-info">返回登录</router-link>
              <el-button class="btn btn-primary" :loading="loading" @click="register">注 册</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </main>
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-copyright">
          <span class="p">Copyright 2014 owecn.com All Rights Reserved</span>
          <span class="p">北京慈福公益基金委员会版权所有</span>
        </div>
        <div class="footer-link">
          <a class="p" href="https://beian.miit.gov.cn/" target="_blank">京ICP备10028793号</a>
          <a class="p" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002189" target="_blank"
            >京公安网备 11010102002189号</a
          >
        </div>
      </div>
    </footer>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" :width="platform == 'web' ? '500px' : '100%'" center append-to-body>
      <div v-html="dialogContent"></div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="btn default" @click="dialogVisible = false">取消</el-button>
          <el-button class="btn comfirm" @click="dialogVisible = false">我已阅读并同意</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  name: "Register",
  data() {
    // 自定义验证函数 - 用户协议
    const validateAgreement = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请阅读并同意用户协议和隐私政策"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      login_bg_image: '',
      countdown: 0, // 倒计时秒数
      timer: null, // 定时器
      form: {
        account: "",
        code: "",
        checked: false,
      },
      rules: {
        account: [
          { required: true, message: "请输入手机号码", trigger: ["blur", "change"] },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: ["blur", "change"] },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
        checked: [{ validator: validateAgreement, trigger: ["blur", "change"] }],
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogContent: "",
    };
  },
  computed: {
    ...mapState(["config", "platform"]),
    // 验证手机号是否有效
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.form.account);
    },
  },
  created() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      let res = await CifuAPI.getConfig()
      if (res.code == 1) {
        this.login_bg_image = res.data.login_bg_image
      }
    },

    handleClickLogo() {
      this.$router.push("/");
    },
    // 获取验证码
    async getVerificationCode() {
      if (!this.isPhoneValid) {
        this.$message.error("请输入正确的手机号码");
        return;
      }

      try {
        // 调用API获取验证码
        const res = await CifuAPI.getSmsCode({
          mobile: this.form.account,
          event: ''
        });
        if (res.code == 1) this.$message.success("验证码已发送");
        // 开始倒计时
        this.startCountdown();
      } catch (error) {
        return false
        // this.$message.error(error.message || "验证码发送失败");
      }
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60; // 设置60秒倒计时
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.countdown--;
      }, 1000);
    },
    register() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    async submit() {
      this.loading = true;
      const res = await CifuAPI.register({
        mobile: this.form.account,
        code: this.form.code,
      });
      if (res.code == 1) {
        this.loading = false;
        this.$router.push("/login");
      }
    },
    showDialog(name) {
      this.dialogTitle = name === "yhxz" ? "用户协议" : "隐私政策";
      this.dialogVisible = true;
      this.dialogContent = name === "yhxz" ? this.config.yonghuxieyi : this.config.yinsizhengce;
    },
  },
  // 组件销毁时清除定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped lang="scss">

.main{
  width: 100%;
  min-width: 1400px;
  display: flex;
  align-items: center;
}
.getCode {
  margin-left: 10px;
  width: 180px;
}
.getCode:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41px;
  line-height: 0;
  border-radius: 40px;
  border-color: #fbce00;
  font-size: 18px;
  color: #663301;
}
.default {
  background-color: #fff;
}
.comfirm {
  background: #fbce00;
}
::v-deep .MsoNormal>span{
  text-indent: 0 !important;
}
</style>
